import React from 'react'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'
import classNames from 'classnames'
import { isEmpty } from 'lodash'
import { Card, CardContent } from '../../components/ui/card'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { Plus, Trash2 } from 'lucide-react'

const title = 'title'
const details = 'details'
const emptyString = ''

const ReleaseNoteCards = ({
	allReleaseNotes,
	handleDeleteReleaseNote,
	handleChangeValue,
	checkIsInvalidReleaseNote,
	addNewReleaseNote,
	releaseNoteToBeEdited,
	handleUpdateReleaseNote,
	handleEditOrSaveReleaseNote,
	newReleaseNotesList,
	areAllCardsValid,
}) => {
	const areDetailsValid = (releaseNote) =>
		(!isEmpty(newReleaseNotesList) && !!releaseNote.id) ||
		(releaseNoteToBeEdited && !areAllCardsValid)

	return (
		<BusyIndicator region={REGIONS.FETCH_RELEASE_NOTES}>
			{isEmpty(allReleaseNotes)
				? 'No Release Note Found.'
				: allReleaseNotes.map((releaseNote, index) => {
					return (
							<div key={releaseNote.createdOn}>
								<Card className='shadow-sm border-0 mb-50'>
									<CardContent className=' p-25'>
										<div className=' f-5 font-semi-bold d-flex '>
											<Label className='mr-auto'>Title</Label>
											<button
												className='pointer'
												onClick={() => handleDeleteReleaseNote(releaseNote)}
											>
												<Trash2 className='mb-1 mr-2 h-4 w-4' />
											</button>
										</div>
										<div className=' d-flex mb--15 '>
											<Input
												type='text'
												value={releaseNote.title || emptyString}
												placeholder='Title'
												onChange={(ev) => handleChangeValue(ev, title, index)}
												readOnly={
													releaseNote.title &&
													releaseNote.id &&
													releaseNote.id !== releaseNoteToBeEdited
												}
												required
												className={classNames('mb-3 title-width', {
													'error-message-border': checkIsInvalidReleaseNote(
														releaseNote.title
													),
												})}
											/>
											<div className='ml-auto mr-auto w-full md:w-1/6'>
												{releaseNoteToBeEdited &&
												releaseNoteToBeEdited === releaseNote.id ? (
													<Button
														onClick={() => handleUpdateReleaseNote(releaseNote)}
														className='w-full'
													>
														<BusyIndicator region={releaseNote.id}>
															Save
														</BusyIndicator>
													</Button>
												) : (
													<Button
														disabled={areDetailsValid(releaseNote)}
														onClick={() =>
															handleEditOrSaveReleaseNote(releaseNote, index)
														}
														className='w-full'
													>
														{releaseNote.id ? (
															<BusyIndicator region={releaseNote.id}>
																{'EDIT'}
															</BusyIndicator>
														) : (
															<BusyIndicator region={`${index}`}>
																{'SAVE'}
															</BusyIndicator>
														)}
													</Button>
												)}
											</div>
										</div>
										{checkIsInvalidReleaseNote(releaseNote.title, title)}

										<Label>Details</Label>
										<Textarea
											value={releaseNote.description || emptyString}
											rows={5}
											placeholder='Details'
											onChange={(ev) =>
												handleChangeValue(ev, 'description', index)
											}
											required
											readOnly={
												releaseNote.description &&
												releaseNote.id &&
												releaseNote.id !== releaseNoteToBeEdited
											}
											className={classNames(
												'custom-scrollbar disabled-resize',
												{
													'error-message-border': checkIsInvalidReleaseNote(
														releaseNote.description
													),
												}
											)}
										/>
										{checkIsInvalidReleaseNote(
											releaseNote.description,
											details
										)}
									</CardContent>
								</Card>
								{index + 1 !== allReleaseNotes.length && (
									<div className='border-left-dark-5 h-50 ml-20 d-flex '>
										<button
											onClick={() => addNewReleaseNote(releaseNote, index + 1)}
											className='mb-1 ml-10 pointer align-item-center'
										>
											<Plus className='h-5 w-5' />
										</button>
									</div>
								)}
							</div>
						)
					})}
		</BusyIndicator>
	)
}

export default ReleaseNoteCards
